import styled from "@emotion/styled";
import { Trans, useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";
import AnswerIcon from "src/images/Icons/newIcons/notifications/questionAnswer.svg";

import newApi from "../../../newApi";
import { TimeComponent } from "../../NewComponents/Default/TimeComponent";
import type { NotificationData } from "./List";
import { Notification } from "./NotificationItem";

interface ForumQuestionAnswerProps {
	notification: NotificationData;
	removeNotification: () => Promise<unknown>;
	className?: string;
}

function ForumQuestionAnswer({
	notification,
	removeNotification,
	className,
}: ForumQuestionAnswerProps) {
	const { openModal } = useModals();
	const { t } = useTranslation();

	const redirect = async () => {
		try {
			const comment = await newApi.getComment(notification.itemId);
			if (!comment) {
				throw new Error("Cannot find comment");
			}
			openModal(ModalsNames.ForumQuestionAnswerModal, {
				parentId: comment.parentId,
			});
		} catch (_error) {
			toast.error(t("errors.commentNotFound"), {
				position: toast.POSITION.BOTTOM_LEFT,
				pauseOnHover: false,
				autoClose: 5000,
			});
		}
	};

	return (
		<Notification
			className={className}
			notification={notification}
			removeNotification={removeNotification}
			onRedirect={redirect}
			Icon={AnswerIcon}
			Primary={
				<Trans
					i18nKey="notifications.forumQuestionAnswer.title"
					values={{ username: notification.username }}
					components={[<strong className="text-black" key="i18Key" />]}
				/>
			}
			Secondary={
				<div className="text-primary size-12 mt-2">
					<TimeComponent
						date={notification.createdAt}
						transKey="notifications.comment.days"
					/>
				</div>
			}
		/>
	);
}

export const ForumQuestionAnswerNotification = styled(ForumQuestionAnswer)``;
